function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './swiper-slide.component.scss';
import template from './swiper-slide.html';


export var SwiperSlideComponent = {
  template: template,
  styles: styles,
  bindings: {},

  require: {
    swiperController: '^uiSwiperCarousel' },

  transclude: true,
  controller: /*#__PURE__*/function () {SwiperSlideComponentController.$inject = ["$element", "$timeout"];
    function SwiperSlideComponentController($element, $timeout) {
      "ngInject";_classCallCheck(this, SwiperSlideComponentController);
      console.log(this);
      this.$timeout = $timeout;
      this.$element = $element;
    }_createClass(SwiperSlideComponentController, [{ key: "$onInit", value: function $onInit()





      {var _this = this;
        this.$element.addClass(styles['swiper-slide-component']);
        var swiperInstance = this.swiperController && this.swiperController.swiperInstance;
        this.isObserverEnabled = swiperInstance &&
        swiperInstance.passedParams &&
        swiperInstance.passedParams.observer;

        if (!this.isObserverEnabled) {
          this.$timeout(function () {// this timeout need, because of Swiper's 'before' and 'after' elements
            _this.swiperController.swiperInstance.appendSlide(_this.$element);
          });
        }
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        if (!this.isObserverEnabled) {
          this.swiperController.swiperInstance.removeSlide(this.$element.index());
        }
      } }, { key: "$postLink", value: function $postLink()

      {
        if (!this.$element.hasClass('swiper-slide')) {
          this.$element.addClass('swiper-slide');
        }
      } }, { key: "index", get: function get() {return this.$element && this.$element.index();} }]);return SwiperSlideComponentController;}() };





if (module.hot) module.hot.accept('./swiper-slide.component.scss');